import React from "react";

// Components
import FormContainer from "../../ui/layout/page/forms-container/form-base-container";
import DateFieldContainer from "../../ui/layout/page/forms-container/form-item-container/date-field-container";
import InputContainer from "../../ui/layout/page/forms-container/form-item-container/input-container";
import NationalityFieldContainer from "../../ui/layout/page/forms-container/form-item-container/nationality-field-container";
import AddressSelect from "../shared/components/address-select";
import BirthDate from "../shared/components/birth-date";
import Country from "../shared/components/country";
import Email from "../shared/components/email";
import FirstName from "../shared/components/first-name";
import Gender from "../shared/components/gender";
import LastName from "../shared/components/last-name";
import Nationality from "../shared/components/nationality";
import Phone from "../shared/components/phone";
import { PersonType } from "./types";
import { Grid } from "@mui/material";

export default function Person({
  firstName,
  lastName,
  birthdate,
  nationality,
  fullStreet,
  address,
  mobile,
  emailBusiness,
  isSameAsAdmin,
  dataPath,
}: PersonType & {
  dataPath: string;
}): React.JSX.Element {
  return (
    <Grid
      className="scd-container-base"
      container
      size={{ xs: 12 }}
      key={dataPath}
    >
      <FormContainer>
        <Gender dataPath={dataPath} />
        <InputContainer>
          <FirstName dataPath={dataPath} value={firstName} />
        </InputContainer>
        <InputContainer>
          <LastName dataPath={dataPath} value={lastName} />
        </InputContainer>
        <DateFieldContainer>
          <BirthDate dataPath={dataPath} value={birthdate} />
        </DateFieldContainer>
        <NationalityFieldContainer>
          <Nationality dataPath={dataPath} value={nationality} />
        </NationalityFieldContainer>
        <AddressSelect
          fullStreet={fullStreet}
          address={address}
          dataPath={dataPath}
        />
        <InputContainer>
          <Country dataPath={dataPath} value={address.country} />
        </InputContainer>
        <InputContainer>
          <Phone
            dataPath={dataPath}
            value={mobile}
            isMobile
            disabled={isSameAsAdmin}
          />
        </InputContainer>
        <InputContainer>
          <Email
            dataPath={dataPath}
            value={emailBusiness}
            isPrivate={false}
            disabled={isSameAsAdmin}
          />
        </InputContainer>
      </FormContainer>
    </Grid>
  );
}
